import styles from './styles.css'

const EmptyState = () => <div className={styles.TicketInspector} />

export default EmptyState
